import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** Snapshot field name (server-side, PascalCase) → existing i18n key. */
const FIELD_LABEL_KEYS: Record<string, string> = {
  Name: 'Name',
  Surname: 'Surname',
  Edrpou: 'EDRPOU',
  Description: 'Description',
  Category: 'Category',
  Addresses: 'Address',
  PhoneNumber: 'Phone',
  Email: 'Email',
  Role: 'Role',
  ExternalCompany: 'Company',
  AdditionalInfos: 'AdditionalContactInfo',
  DateStart: 'Start',
  DateEnd: 'End',
  Type: 'CrmEventType',
  ExternalCompanies: 'Companies',
  Contacts: 'Contacts',
  Attachment: 'Attachments',
  Region: 'Region',
};

export const historyFieldLabelKey = (field: string): string => FIELD_LABEL_KEYS[field] ?? field;

const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?/;

/** Dates come as "yyyy-MM-ddTHH:mm:ss" without zone (server stores UTC) → shown in local time. */
export const formatHistoryValue = (value?: string | null): string => {
  if (value === undefined || value === null || value === '') return '—';
  if (ISO_DATE_TIME.test(value)) {
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : value;
  }
  return value;
};

export const formatHistoryDate = (iso: string): string => dayjs.utc(iso).local().format('DD/MM/YYYY HH:mm');
